const sizeSelect = document.getElementById("pa_size");
const buyButtons = document.querySelectorAll(".variation-ctas button");

const firstButton = document.getElementById("cs_0"); // Get the first button

if (sizeSelect) {
  sizeSelect.addEventListener("change", () => {

    const selectedSizeId = sizeSelect.value;

    buyButtons.forEach((button) => {
      button.classList.remove("active");
    });


    if (selectedSizeId) {

      let targetButton = Array.from(buyButtons).find(
        (button) => button.dataset.assetId === selectedSizeId);

      if (targetButton) {
        targetButton.classList.add("active");
      } else {
        firstButton.classList.add("active");
      }

    } else {

      const selectedOption = sizeSelect.options[sizeSelect.selectedIndex];

      let targetButton = Array.from(buyButtons).find(
        (button) => button.dataset.size === selectedOption.dataset.size
      );

      if (targetButton) {
        targetButton.classList.add("active");
      } else {
        firstButton.classList.add("active");
      }

      if (!selectedOption.dataset.size) {
        buyButtons.forEach((button) => {
          button.classList.remove("active");
        });
      }

    }


  });
}
